import { render, staticRenderFns } from "./batchInvoiceDialog.vue?vue&type=template&id=b6735d82&scoped=true"
import script from "./batchInvoiceDialog.vue?vue&type=script&lang=js"
export * from "./batchInvoiceDialog.vue?vue&type=script&lang=js"
import style0 from "./batchInvoiceDialog.vue?vue&type=style&index=0&id=b6735d82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6735d82",
  null
  
)

export default component.exports